import humps from 'humps'
import api from 'api'
import { IDc3CertificateDownloadResponse } from 'components/dc3Certificate/types'

export interface GetUserDc3CertificateDownloadDataParams {
  userId: number
  courseId: number
}

const getUserDc3CertificateDownloadData = async ({
  userId,
  courseId,
}: GetUserDc3CertificateDownloadDataParams) => {
  const { data } = await api.post<IDc3CertificateDownloadResponse>(
    `/users/${userId}/normative_legal_attestations/${courseId}/download_data`
  )

  return humps.camelizeKeys(data) as IDc3CertificateDownloadResponse
}

export default getUserDc3CertificateDownloadData
